export const SURVEY_APP_URL = "https://assisi-parish-mis.emergent.host";
export const FAMILY_SURVEY_URL = "/survey";
export const SURVEY_SHORT_LINK = "https://mabuhayparish.org/survey";
export const GKK_PORTAL_URL = "https://francis-gkk-fmis.emergent.host";
export const FRANCIS_CONNECT_URL = "https://francisconnect.mabuhayparish.org";
export const YOUTH_PULSE_URL = "https://youthpulse.mabuhayparish.org";
export const PARISH_ATTENDANCE_URL = "https://registration.mabuhayparish.org";
